import React, { Component } from 'react';
import ArticleJoinForm  from './ArticleJoinForm';
import { BiEnvelope } from "react-icons/bi";
 
class JoinUsingEmail extends Component {
    constructor(props) {
      super(props);
      this.state = {
          data: ""
      }
    }
 
  saveDataContent2 = () => {
      this.setState({ data: <ArticleJoinForm props={this.props} />});
  }
 
  render() {
    return (
      <div>
          <a className="text-blue font-weight-bold" onClick={this.saveDataContent2}>Not a Member yet?</a>
          <p>Join my community. It's FREE!</p>
          <p>After you join you can get unlimited free access to my
          personal library of practical wellness resources and discover
          how to have long-lasting vitality and well-being with shaklee
          products.</p>
          <div className="btn-join-email bg-success py-2 px-3 my-5 text-center" onClick={this.saveDataContent2}>
              <h3 className="text-white"> 
                  <span className="float-left border-right pr-3"><BiEnvelope className="icon-message h1"/></span>
                  <span>Join Using Email</span>
              </h3>
          </div>
          <div className="">
            { this.state.data }
          </div>
        <style jsx global>{`
          .btn-join-email{
              background-color: #43a649!important;
              width:100%;
              max-width:450px;
              cursor: pointer;
          } 

          .btn-join-email:hover,
          .btn-join-email:active,
          .btn-join-email:focus{
              text-decoration: none;
              background-color: #5ebe64!important;
          }

          .btn-join-email h3{
              text-align:center;
          }

        `}</style>
      </div>
    );
  }
}
 
export default JoinUsingEmail;